export default __webpack_public_path__ + "static/qa-d482d5be2ae55975449b17e18cdf7727.svg";